import { ArchiveList } from '@components/archiveList';
import { Breadcrumb } from '@components/breadcrumb';
import { useFragment } from 'react-relay';
import { archivePageFragment } from './lib';
import type { ArchivePageProps } from './types';

export const ArchivePage: React.FC<ArchivePageProps> = (props) => {
  const page = useFragment(archivePageFragment, props.page);

  return (
    <div>
      <Breadcrumb data={page.breadcrumbs} />
      <div className="Widget-container Base-container relative mx-auto flex w-full max-w-[820px] flex-wrap items-start justify-between max-[1100px]:mx-auto max-[1100px]:max-w-[565px] max-[1100px]:w-[calc(100vw-80px)] max-[600px]:max-w-[565px] max-[600px]:w-[calc(100vw-40px)]">
        <ArchiveList component={page.archive} location={props.location} />
      </div>
    </div>
  );
};
